import React from 'react';

const Home = () => <></>;
export default Home;
